"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalUploadController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const platform_express_1 = require("@nestjs/platform-express");
const multer_1 = require("multer");
const path_1 = require("path");
const fs_1 = require("fs");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const medical_upload_link_entity_1 = require("./medical-upload-link.entity");
const medical_history_service_1 = require("./medical-history.service");
const UPLOAD_DIR = (0, path_1.join)(process.cwd(), 'uploads', 'medical-public');
const ALLOWED_MIME = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
const MAX_FILES = 6;
if (!(0, fs_1.existsSync)(UPLOAD_DIR))
    (0, fs_1.mkdirSync)(UPLOAD_DIR, { recursive: true });
let MedicalUploadController = class MedicalUploadController {
    constructor(linkRepo, medicalHistoryService) {
        this.linkRepo = linkRepo;
        this.medicalHistoryService = medicalHistoryService;
    }
    async getLinkInfo(token) {
        const link = await this.linkRepo.findOne({
            where: { token },
            relations: ['customer'],
        });
        if (!link)
            throw new common_1.NotFoundException('Upload link not found or has expired.');
        if (link.expiresAt && link.expiresAt < new Date()) {
            throw new common_1.BadRequestException('This upload link has expired.');
        }
        return {
            token,
            customerId: link.customerId,
            customerName: link.customer?.name,
            patientId: link.customer?.patientId,
            requestedDocType: link.requestedDocType,
            notes: link.notes,
            files: link.files ?? [],
            uploadComplete: link.uploadComplete,
            maxFiles: MAX_FILES,
            expiresAt: link.expiresAt,
        };
    }
    async uploadFiles(token, files) {
        const link = await this.linkRepo.findOne({ where: { token } });
        if (!link)
            throw new common_1.NotFoundException('Upload link not found.');
        if (link.expiresAt && link.expiresAt < new Date())
            throw new common_1.BadRequestException('Link expired.');
        if (link.uploadComplete)
            throw new common_1.BadRequestException('Documents have already been submitted. New uploads are locked.');
        const existing = link.files ?? [];
        if (existing.length + files.length > MAX_FILES) {
            throw new common_1.BadRequestException(`Maximum ${MAX_FILES} files allowed. You already have ${existing.length}.`);
        }
        const newFiles = files.map((file) => ({
            url: `/uploads/medical-public/${file.filename}`,
            originalName: file.originalname,
            mimeType: file.mimetype,
            size: file.size,
            type: file.mimetype === 'application/pdf' ? 'document' : 'image',
            uploadedAt: new Date().toISOString(),
        }));
        link.files = [...existing, ...newFiles];
        await this.linkRepo.save(link);
        return { success: true, files: link.files, total: link.files.length };
    }
    async deleteFile(token, body) {
        const link = await this.linkRepo.findOne({ where: { token } });
        if (!link)
            throw new common_1.NotFoundException('Upload link not found.');
        if (link.expiresAt && link.expiresAt < new Date())
            throw new common_1.BadRequestException('Link expired.');
        if (link.uploadComplete)
            throw new common_1.BadRequestException('Documents have already been submitted. Files can no longer be removed.');
        if (!body.url)
            throw new common_1.BadRequestException('File URL is required.');
        const existing = link.files ?? [];
        const file = existing.find((item) => item.url === body.url);
        if (!file)
            throw new common_1.NotFoundException('File not found.');
        const absolutePath = (0, path_1.join)(process.cwd(), file.url.replace(/^\//, ''));
        if ((0, fs_1.existsSync)(absolutePath)) {
            (0, fs_1.unlinkSync)(absolutePath);
        }
        link.files = existing.filter((item) => item.url !== body.url);
        await this.linkRepo.save(link);
        return { success: true, files: link.files, total: link.files.length };
    }
    async markComplete(token) {
        await this.medicalHistoryService.completeUploadLink(token);
        return { success: true };
    }
};
exports.MedicalUploadController = MedicalUploadController;
tslib_1.__decorate([
    (0, common_1.Get)(':token'),
    tslib_1.__param(0, (0, common_1.Param)('token')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", Promise)
], MedicalUploadController.prototype, "getLinkInfo", null);
tslib_1.__decorate([
    (0, common_1.Post)(':token/upload'),
    (0, common_1.UseInterceptors)((0, platform_express_1.FilesInterceptor)('files', MAX_FILES, {
        storage: (0, multer_1.diskStorage)({
            destination: UPLOAD_DIR,
            filename: (_req, file, cb) => {
                const unique = `${Date.now()}-${Math.round(Math.random() * 1e9)}`;
                cb(null, `${unique}${(0, path_1.extname)(file.originalname).toLowerCase()}`);
            },
        }),
        fileFilter: (_req, file, cb) => {
            if (ALLOWED_MIME.includes(file.mimetype.toLowerCase())) {
                cb(null, true);
            }
            else {
                cb(new common_1.BadRequestException('Only PDF and image files are accepted.'), false);
            }
        },
        limits: { fileSize: 10 * 1024 * 1024 },
    })),
    tslib_1.__param(0, (0, common_1.Param)('token')),
    tslib_1.__param(1, (0, common_1.UploadedFiles)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Array]),
    tslib_1.__metadata("design:returntype", Promise)
], MedicalUploadController.prototype, "uploadFiles", null);
tslib_1.__decorate([
    (0, common_1.Delete)(':token/file'),
    tslib_1.__param(0, (0, common_1.Param)('token')),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MedicalUploadController.prototype, "deleteFile", null);
tslib_1.__decorate([
    (0, common_1.Post)(':token/complete'),
    tslib_1.__param(0, (0, common_1.Param)('token')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", Promise)
], MedicalUploadController.prototype, "markComplete", null);
exports.MedicalUploadController = MedicalUploadController = tslib_1.__decorate([
    (0, common_1.Controller)('medical-upload'),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(medical_upload_link_entity_1.MedicalUploadLink)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof medical_history_service_1.MedicalHistoryService !== "undefined" && medical_history_service_1.MedicalHistoryService) === "function" ? _b : Object])
], MedicalUploadController);
